import { Component, OnInit } from '@angular/core';
import { ModalService } from 'src/app/common/modal.service';

@Component({
  selector: 'app-modal-list-template',
  templateUrl: './modal-list-template.component.html',
  styleUrls: ['./modal-list-template.component.scss'],
})
export class ModalListTemplateComponent implements OnInit {
  marcas: string[] = this.modalService.getInputData().list;
  title: string = this.modalService.getInputData().title;
  constructor(private modalService: ModalService) {}

  ngOnInit(): void {}
}
